import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import axios from 'axios'
import store from './views/Stores/store.js';

Vue.config.productionTip = false

Vue.use(ArgonDashboard)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

const base = axios.create({
	// baseURL: 'https://api-portal-dev-dreamfill.azurewebsites.net'
	baseURL: 'https://api-portal.dreamfillservices.com'
})

Vue.prototype.$http = base
